import React from 'react';
import PropTypes from 'prop-types';

import {connectModuleEnv} from '../oe-module-env';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import retardUpdate from '../../lib/react/update-retarder';
import OEAnimateHelper from '../../lib/animation/oe-animate-helper';
import OEToolbox from '../../lib/tools/oe-toolbox';

export class OELogoView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            masked: false,
            style: this.createStyle(props)
        };

        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.config, this.props.config, true))    {
            this.updateMaskedState(nextProps);
        }

        if(!OEToolbox.shallowEqual(nextProps.offsets, this.props.offsets, true))    {
            this.updateStyleState(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateMaskedState(props)   {
        props = props || this.props;
        if(typeof(props.config) !== 'object' || !this.oe.isReady())  return false;
        let masked = false;

        if(props.config.mask)  {
            if(props.config.mask.uiController)  {
                if(typeof(props.config.mask.uiController) === 'number')    {
                    masked = this.oe.sharedInterface.getUIControllerVisible({value: props.config.mask.uiController});
                } else {
                    for(let i = 0; i < props.config.mask.length; ++i) {
                        masked = this.oe.sharedInterface.getUIControllerVisible({value: props.config.mask[i]});
                        if(masked)  break;
                    }
                }
            }
        }

        this.setState({masked: masked});
    }

    createStyle(props)   {
        props = props || this.props;
        if(!props.offsets)  return null;

        let style = {};
        style.bottom = props.offsets.bottom.value;
        style.left = props.offsets.left.value;
        style.transition = OEAnimateHelper.transitionForInsets({
            bottom: props.offsets.bottom.animate, 
            left: props.offsets.left.animate
        });

        return style;
    }

    updateStyleState(props)  {
        this.setState({style: this.createStyle(props)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({ masked: false });
            return;
        }
        
        retardUpdate(this, () => {
            this.updateMaskedState();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(typeof(this.props.config) !== 'object' || !this.props.config.mask || !this.props.config.mask.uiController)  return;

        if(typeof(this.props.config.mask.uiController) === 'number')    {
            if(userInfo.type.value != this.props.config.mask.uiController)  return;
        } else {
            if(!this.props.config.mask.includes(userInfo.type.value))  return;
        }

        this.updateMaskedState();
    }

    render()    {
        if(!this.props.config)  return null;
        let src = typeof(this.props.config) === 'string' ? this.props.config : (typeof(this.props.config.enabled) === 'undefined' || this.props.config.enabled ? this.props.config.src : undefined);
        if(!src)    return null;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div
                    className={'logo-view ' + (this.state.masked ? 'masked ' : '') + this.props.className}
                    style={this.state.style}
                >
                    <img src={src} draggable="false"/>
                </div>
            </React.Fragment>
        );
    }
}

OELogoView.defaultProps = {
    moduleId: '',
    className: ''
};

OELogoView.propTypes = {
    moduleId: PropTypes.string,
    className: PropTypes.string,
    config: PropTypes.oneOfType([
        PropTypes.shape({
            enabled: PropTypes.bool,
            src: PropTypes.string,
            mask: PropTypes.shape({
                uiController: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])
            }),
        }),
        PropTypes.string
    ]),
    offsets: PropTypes.shape({
        bottom: PropTypes.shape({
            value: PropTypes.number, animate: PropTypes.bool
        }),
        left: PropTypes.shape({
            value: PropTypes.number, animate: PropTypes.bool
        })
    })
};

export default connectModuleEnv((env) => {
    return {
        offsets: {
            bottom: {value: env.ui.bottomEdgeOffset.value, animate: env.ui.bottomEdgeOffset.animate},
            left: {value: env.ui.leftSlideInContainer.offset, animate: env.ui.leftSlideInContainer.animate}
        }
    };
})(OELogoView);